<template>
  <div class="h-min-content w-full">
    <Wrapper class="max-w-2xl">
      <div class="mb-3 text-left">
        <h2 class="text-xl"><b>Información del tarifario</b></h2>
        <p class="text-gray-500">Ingrese la información del tarifario</p>
      </div>
      <div class="mx-auto max-w-2xl">
        <div
          :class="
            tariffFormat !== '' ? 'mb-5 pb-5 border-b border-gray-100' : ''
          "
        >
          <BaseSelect
            ref="channel"
            id="channel"
            label="Tipo de formato"
            :selectOptions="formOptions.optionsTariffFormats"
            v-model="tariffFormat"
            :required="true"
          />
        </div>

        <div v-if="massiveUpload && tariffFormat">
          <FormUploadMassive :tariffFormat="tariffFormat" />
        </div>

        <div v-else>
          <FormDepositProduct
            v-if="tariffFormat === '1'"
            title="Tarifario tipo deposito"
            description="Ingrese la información del tarifario"
          />
          <FormCreditCardProduct
            v-if="tariffFormat === '2'"
            title="Tarifario tipo tarjeta de crédito"
            description="Ingrese la información del tarifario"
          />
          <FormCreditProduct
            v-if="tariffFormat === '3'"
            title="Tarifario tipo credito"
            description="Ingrese la información del tarifario"
          />
        </div>
      </div>
    </Wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormDepositProduct from '@/components/Dashboard/Tariffs/FormTariff/FormDepositProduct.vue'
import FormCreditCardProduct from '@/components/Dashboard/Tariffs/FormTariff/FormCreditCardProduct.vue'
import FormCreditProduct from '@/components/Dashboard/Tariffs/FormTariff/FormCreditProduct.vue'
import FormUploadMassive from '@/components/Dashboard/Tariffs/FormTariff/FormUploadMassive.vue'
export default {
  components: {
    FormDepositProduct,
    FormCreditCardProduct,
    FormCreditProduct,
    FormUploadMassive,
  },
  data() {
    return {
      tariffFormat: '',
      massiveUpload: false,
    }
  },
  computed: {
    ...mapState({
      formOptions: 'form',
    }),
  },
  mounted() {
    if (this.$route.query.massive) {
      this.massiveUpload = true
    }
  },
}
</script>

<style></style>
